import { type Moment } from 'moment'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { resolveExperienceDateRangeDisplay } from 'lib/search/experiences'
import useExperienceSearchLabels from './useExperienceSearchLabels'

function useExperienceDateDisplayValue(
  checkinDate: Moment | undefined,
  checkoutDate: Moment | undefined,
  fallback?: string,
): string | undefined {
  const intl = useIntl()
  const { todayLabel, tomorrowLabel, thisWeekendLabel } = useExperienceSearchLabels()

  return useMemo(() => {
    if (!checkinDate) {
      return fallback
    }
    const { preset, rangeLabel } = resolveExperienceDateRangeDisplay(checkinDate, checkoutDate, intl.locale)
    if (preset === 'today') return todayLabel
    if (preset === 'tomorrow') return tomorrowLabel
    if (preset === 'weekend') return thisWeekendLabel
    return rangeLabel ?? fallback
  }, [checkinDate, checkoutDate, fallback, intl.locale, todayLabel, tomorrowLabel, thisWeekendLabel])
}

export default useExperienceDateDisplayValue
